import React from 'react';
import {Link, withStyles} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import i18n from '../../i18n';
import TableCell from '@material-ui/core/TableCell/TableCell';

export const xOrder = (order) => {
    return order === 'desc' ? 'asc' : 'desc';
};

/**
 *
 * @param children
 * @param classes
 * @param action   Number or url to trigger, when number, it iterate through a and button elements using this number
 * @returns {*}
 * @constructor
 */
const TableCellSortable = ({active, order, children, classes, action, onClick, ...props}) => (
    <TableCell {...props}>
        <Tooltip
            title={i18n.get('default.sort_title')}
        >
            <TableSortLabel
                active={active}
                direction={order === 'asc' ? 'asc' : 'desc'}
            >
                <Link
                    underline="none"
                    href={action}
                    onClick={onClick}
                >
                    {children}
                </Link>
            </TableSortLabel>
        </Tooltip>
    </TableCell>
);

const styles = theme => ({
    clickable: {
        cursor: 'pointer',
    },
});

export default withStyles(styles)(TableCellSortable);
